import {useCallback} from 'react';

import {YAxisValues} from '../../types';
import {useMaybeWorkspaceSettingsContext} from '../../WorkspaceSettingsContextProvider';
import {
  SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT,
  SEMANTIC_LEGEND_PALETTE_DEFAULT,
} from './colorPalettes';

export const useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig =
  () => {
    const workspaceSettings = useMaybeWorkspaceSettingsContext();
    return useCallback(
      (yAxisValue: YAxisValues | undefined) => {
        if (yAxisValue === YAxisValues.Config_Categories) {
          return (
            workspaceSettings?.semanticLegendPalette ??
            SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT
          );
        }
        return (
          workspaceSettings?.semanticLegendPalette ??
          SEMANTIC_LEGEND_PALETTE_DEFAULT
        );
      },
      [workspaceSettings]
    );
  };
